import { render, staticRenderFns } from "./RealizationScopeForm.vue?vue&type=template&id=64a30298"
import script from "./RealizationScopeForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RealizationScopeForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports